import axios from 'axios';
import { correlationIdGenerator, GLOBAL_PREF_CODE } from '../utils/ModuleMap';
import envConfig from '../envConfig';

// ============================================
// Token Cache Management (Option 1 + 3)
// ============================================
// class TokenCache {
//   constructor() {
//     this.idaasToken = null;
//     this.idaasExpiresAt = null;
//     this.cardToken = null;
//     this.cardExpiresAt = null;
//     this.refreshTimers = {};
//     this.BUFFER_MS = 30000; // Refresh 30s before expiry
//   }

//   /**
//    * Check if cached token is still valid
//    * @param {number} expiresAt - Expiry timestamp in ms
//    * @returns {boolean}
//    */
//   isTokenValid(expiresAt) {
//     if (!expiresAt) return false;
//     const now = Date.now();
//     return (expiresAt - now) > this.BUFFER_MS;
//   }

//   /**
//    * Get cached IDAAS token if valid, otherwise return null
//    * @returns {string|null}
//    */
//   getCachedIdaasToken() {
//     if (this.isTokenValid(this.idaasExpiresAt)) {
//       return this.idaasToken;
//     }
//     return null;
//   }

//   /**
//    * Get cached Card token if valid, otherwise return null
//    * @returns {string|null}
//    */
//   getCachedCardToken() {
//     if (this.isTokenValid(this.cardExpiresAt)) {
//       return this.cardToken;
//     }
//     return null;
//   }

//   /**
//    * Store IDAAS token with expiry
//    * @param {string} token
//    * @param {number} expiresIn - TTL in seconds
//    */
//   setIdaasToken(token, expiresIn) {
//     this.idaasToken = token;
//     this.idaasExpiresAt = Date.now() + (expiresIn * 1000);
//     console.log('token', token);
//     console.log(
//       `[TokenCache] IDAAS token cached, expires in ${expiresIn}s at ${new Date(
//         this.idaasExpiresAt
//       ).toISOString()}`
//     );
//   }

//   /**
//    * Store Card token with expiry
//    * @param {string} token
//    * @param {number} expiresIn - TTL in seconds
//    */
//   setCardToken(token, expiresIn) {
//     this.cardToken = token;
//     this.cardExpiresAt = Date.now() + (expiresIn * 1000);
//     console.log(
//       `[TokenCache] Card token cached, expires in ${expiresIn}s at ${new Date(
//         this.cardExpiresAt
//       ).toISOString()}`
//     );
//   }

//   /**
//    * Clear cached tokens
//    */
//   clear() {
//     this.idaasToken = null;
//     this.idaasExpiresAt = null;
//     this.cardToken = null;
//     this.cardExpiresAt = null;
//     this.clearTimers();
//   }

//   /**
//    * Clear all refresh timers
//    */
//   clearTimers() {
//     Object.entries(this.refreshTimers).forEach(([key, timerId]) => {
//       clearInterval(timerId);
//       delete this.refreshTimers[key];
//     });
//   }

//   /**
//    * Start background refresh cycle for IDAAS token
//    * @param {Function} refreshFn - Async function that returns {authorization_token, expires_in}
//    * @param {string} tokenType - 'idaas' or 'card'
//    * @param {Function} dispatchFn - Redux dispatch wrapper (optional)
//    * @param {string} actionType - Redux action type (optional)
//    */
//   startRefreshCycle(refreshFn, tokenType = 'idaas', dispatchFn = null, actionType = null) {
//     // Clear existing timer if any
//     if (this.refreshTimers[tokenType]) {
//       clearInterval(this.refreshTimers[tokenType]);
//     }

//     // Determine which token to check
//     const getExpiresAt = () => (tokenType === 'idaas' ?this.idaasExpiresAt :this.cardExpiresAt);

//     const refreshInterval = () => {
//       const expiresAt = getExpiresAt();
//       if (!expiresAt) {
//         console.warn(
//           `[TokenCache] No ${tokenType} token expiry found, skipping refresh`
//         );
//         return;
//       }

//       const timeUntilExpiry = expiresAt - Date.now();
//       // Refresh when 30s or less remaining
//       if (timeUntilExpiry <= this.BUFFER_MS) {
//         this.performRefresh(refreshFn, tokenType, dispatchFn, actionType);
//       }
//     };

//     // Check every 30 seconds if refresh is needed
//     this.refreshTimers[tokenType] = setInterval(refreshInterval, 30000);
//     console.log(`[TokenCache] Started ${tokenType} token refresh cycle`);

//     // Initial refresh attempt if token missing or expired
//     if (
//       tokenType === 'idaas'
//       && !this.isTokenValid(this.idaasExpiresAt)
//     ) {
//       this.performRefresh(refreshFn, tokenType, dispatchFn, actionType);
//     } else if (
//       tokenType === 'card'
//       && !this.isTokenValid(this.cardExpiresAt)
//     ) {
//       this.performRefresh(refreshFn, tokenType, dispatchFn, actionType);
//     }
//   }

//   /**
//    * Perform token refresh
//    * @param {Function} refreshFn - Async function that returns {authorization_token,expires_in}
//    * @param {string} tokenType - 'idaas' or 'card'
//    * @param {Function} dispatchFn - Redux dispatch wrapper (optional)
//    * @param {string} actionType - Redux action type (optional)
//    */
//   async performRefresh(refreshFn, tokenType = 'idaas', dispatchFn = null, actionType = null) {
//     try {
//       console.log(`[TokenCache] Refreshing ${tokenType} token...`);
//       const response = await refreshFn();

//       if (!response?.authorization_token) {
//         throw new Error('No token in response');
//       }

//       if (tokenType === 'idaas') {
//         this.setIdaasToken(
//           response.authorization_token,
//           response.expires_in
//         );
//       } else if (tokenType === 'card') {
//         this.setCardToken(
//           response.authorization_token,
//           response.expires_in
//         );
//       }

//       // Dispatch to Redux if dispatch function provided
//       if (dispatchFn && actionType) {
//         dispatchFn({
//           type: actionType,
//           payload: response.authorization_token,
//         });
//       }

//       console.log(`[TokenCache] ${tokenType} token refreshed successfully`);
//       return response.authorization_token;
//     } catch (error) {
//       console.error(
//         `[TokenCache] Failed to refresh ${tokenType} token:`,
//         error
//       );
//       throw error;
//     }
//   }

//   /**
//    * Stop all refresh cycles
//    */
//   stopRefreshCycles() {
//     this.clearTimers();
//     console.log('[TokenCache] All refresh cycles stopped');
//   }
// }

// Global instance
// export const tokenCache = new TokenCache();

// export const getIDAASTokenAPI = async (fetchClient, env) => {
//   // Check cache first
//   const cachedToken = tokenCache.getCachedIdaasToken();
//   if (cachedToken) {
//     console.log('[getIDAASTokenAPI] Returning cached IDAAS token');
//     return {
//       authorization_token: cachedToken,
//       expires_in: Math.floor(
//         (tokenCache.idaasExpiresAt - Date.now()) / 1000
//       ),
//       fromCache: true,
//     };
//   }

//   // Real implementation when ready
//   try {
//     const headers = {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//     };

//     const body = {
//       scope: ['/privacy/preferences/search::post', '/privacy/preferences::post'],
//     };

//     console.log(`[getIDAASTokenAPI] Requesting new IDAAS token from server
// ${envConfig[env]?.EPCC_TOKEN_URL}`);
//     // Uncomment when token service is ready:
//     const tokenResp = await fetchClient(envConfig[env]?.EPCC_TOKEN_URL, {
//       method: 'POST',
//       headers,
//       body: JSON.stringify(body),
//     });
//     console.log(`[getIDAASTokenAPI] Received response from server ${tokenResp.status}
// ${tokenResp.statusText}`);
//     const tokenRes = tokenResp?.data;

//     //! Mock token response for now
//     // const tokenRes = {
//     //   authorization_token: 'mocked-token-for-testing',
//     //   expires_in: 3600,
//     // };

//     // Cache the token
//     tokenCache.setIdaasToken(tokenRes.authorization_token, tokenRes.expires_in);

//     return tokenRes;
//   } catch (err) {
//     const errorData = {
//       message: err.message,
//       response: err.response?.data,
//       status: err.response?.status,
//       timestamp: new Date().toISOString(),
//     };
//     console.error('[getIDAASTokenAPI] Error:', errorData);
//     return { error: err, errorData };
//   }
// };

/**
 * Initialize token refresh cycle on app load
 * Should be called once during application initialization (e.g., in loadModuleData)
 * @param {Function} dispatchFn - Redux dispatch function wrapper
 * @param {string} actionType - Redux action type for storing token (e.g., 'SET_APPLICATION_TOKEN')
 */
// export const initializeTokenRefreshCycle = async (
//   dispatchFn,
//   actionType = 'SET_APPLICATION_TOKEN',
//   fetchClient,
//   env
// ) => {
//   try {
//     console.log('[initializeTokenRefreshCycle] Starting token refresh management...');

//     // Initial fetch and cache
//     const idaasTokenResponse = await getIDAASTokenAPI(fetchClient, env);

//     if (idaasTokenResponse?.error) {
//       throw idaasTokenResponse.error;
//     }

//     if (dispatchFn && actionType) {
//       dispatchFn({
//         type: actionType,
//         payload: idaasTokenResponse.authorization_token,
//       });
//     }

//     // Start background refresh cycle (every 30s check if refresh needed)
//     // For a 10-min token (600s), this will refresh at 9:30 mark
//     // Pass dispatch and actionType so token gets updated in Redux on refresh
//     tokenCache.startRefreshCycle(
//       getIDAASTokenAPI,
//       'idaas',
//       dispatchFn,
//       actionType
//     );

//     console.log('[initializeTokenRefreshCycle] Token refresh cycle initialized');
//     return idaasTokenResponse.authorization_token;
//   } catch (error) {
//     console.error('[initializeTokenRefreshCycle] Failed to initialize:', error);
//     throw error;
//   }
// };

/**
 * Get IDAAS token (from cache if valid, otherwise refresh)
 * @returns {string} Authorization token
 */
// export const getIdaasTokenWithCache = () => {
//   const token = tokenCache.getCachedIdaasToken();
//   if (!token) {
//     throw new Error(
//       'IDAAS token not available. Call initializeTokenRefreshCycle() first.'
//     );
//   }
//   return token;
// };

// export const getCardTokenAPI = async (fetchClient, env) => {
//   try {
//     const headers = {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//     };

//     const body = {
//       scope: ['*'],
//     };

//     // Uncomment when card token service is ready:
//     const tokenResp = await axios.post(envConfig[env]?.CARD_API_TOKEN, body, { headers });
//     const tokenRes = tokenResp?.data;

//     // //! Mock card token response for now
//     // const tokenRes = {
//     //   authorization_token:
//     //   expires_in: 600,
//     // };

//     // Cache the card token
//     fetchClient();

//     return tokenRes;
//   } catch (err) {
//     const errorData = {
//       message: err.message,
//       response: err.response?.data,
//       status: err.response?.status,
//       timestamp: new Date().toISOString(),
//     };
//     console.error('[getCardTokenAPI] Error:', errorData);
//     return { error: err, errorData };
//   }
// };

// export const initializeCardTokenOnLoad = async (
//   dispatchFn,
//   actionType = 'SET_CARD_TOKEN',
//   fetchClient, env
// ) => {
//   try {
//     const cardTokenResponse = await getCardTokenAPI(fetchClient, env);
//     console.log('[initializeCardTokenOnLoad] Card token response:', cardTokenResponse);

//     if (cardTokenResponse?.error) {
//       throw cardTokenResponse.error;
//     }

//     if (dispatchFn && actionType) {
//       dispatchFn({
//         type: actionType,
//         payload: cardTokenResponse.authorization_token,
//       });
//     }

//     return cardTokenResponse.authorization_token;
//   } catch (error) {
//     console.error('[initializeCardTokenOnLoad] Failed to initialize:', error);
//     throw error;
//   }
// };

// ============================================
// Token Cache Management (Option 1 + 3)
// ============================================

export const postPrivacyPreferenceSearchDetails = async ({
  emailAddress,
  appToken,
  env
}) => {
  try {
    var _envConfig$env, _envConfig$env2;
    // Step 1: Get JWT
    // const tokenRes = await getApplicationToken({ appId, secret, tokenUrl: tokenUrlParam });

    // console.log('searchUrlParam:', env, envConfig[env]?.EPCC_SEARCH_URL,);

    if (!appToken) {
      throw new Error('Token not received');
    }
    const jwt = appToken;

    // Step 2: Build search payload
    const searchPayload = {
      requestorInformation: {
        // confirm this value from Angular config
        interfaceRelationshipId: (_envConfig$env = envConfig[env]) === null || _envConfig$env === void 0 ? void 0 : _envConfig$env.EPCC_INTERFACE_RELATIONSHIP_ID
      },
      customerDetails: {
        entityClassificationCode: 'EMAIL',
        entityFormatCode: 'EMAIL',
        entityValue: emailAddress
      },
      preferenceRequestGroup: [{
        preferenceCode: GLOBAL_PREF_CODE
      }],
      auditInformation: {
        correlationId: correlationIdGenerator()
      }
    };
    const searchHeaders = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`
    };
    const searchResp = await axios.post((_envConfig$env2 = envConfig[env]) === null || _envConfig$env2 === void 0 ? void 0 : _envConfig$env2.EPCC_SEARCH_URL, searchPayload, {
      headers: searchHeaders
    });
    return searchResp.data;

    //! mock response for now
    // return {
    //   status: {
    //     requestTrackId: '1234',
    //     responseCode: 'SUCCESS',
    //   },
    //   entityPreferenceResponse: {
    //     entityValue: 'a@a.com',
    //     preferenceCodeDetails: [
    //       {
    //         preferenceList: [],
    //         preferenceCode: 'MKTGBEML',
    //         preferenceEffectiveTs: '2025-11-18 10:39:00.580881',
    //         preferenceStatus: 'I',
    //         prefLockInd: 'No',
    //         derivedIndicator: 'N',
    //       },
    //     ],
    //   },
    // };
  } catch (error) {
    var _error$response, _error$response2;
    const errorData = {
      message: error.message,
      response: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data,
      status: (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status,
      emailAddress,
      timestamp: new Date().toISOString()
    };
    console.error('postPrivacyPreferenceSearchDetails error:', errorData);
    return {
      error,
      errorData
    };
  }
};

/**
 *
 * @returns format "YYYY-MM-DD-HH.mm.ss.SSSSSS"
 */
const formatOptioTimestamp = () => {
  const now = new Date();
  const pad = (n, width = 2) => n.toString().padStart(width, '0');
  const datePart = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const timePart = `${pad(now.getHours())}.${pad(now.getMinutes())}.${pad(now.getSeconds())}`;
  const microseconds = `${pad(now.getMilliseconds(), 3)}000`;
  return `${datePart}-${timePart}.${microseconds}`;
};
export const updatePrivacyPreferences = async ({
  emailAddress,
  preferenceStatus,
  // appId = privacyAppId,
  // secret = privacySecret,
  // tokenUrl: tokenUrlParam = tokenUrl,
  // updateUrl: updateUrlParam = updateUrl,
  appToken,
  env
}) => {
  try {
    var _envConfig$env3, _envConfig$env4;
    // Step 1: Get JWT
    // const tokenRes = await getApplicationToken({ appId, secret, tokenUrl: tokenUrlParam });

    // if (!tokenRes?.authorization_token) {
    //   if (tokenRes?.error) return tokenRes;
    //   throw new Error('Token not received');
    // }

    if (!appToken) {
      throw new Error('Token not received');
    }
    const jwt = appToken;

    // Step 2: Build correct Optio update payload
    const updatePayload = {
      requestorInformation: {
        interfaceRelationshipId: (_envConfig$env3 = envConfig[env]) === null || _envConfig$env3 === void 0 ? void 0 : _envConfig$env3.EPCC_INTERFACE_RELATIONSHIP_ID
      },
      customerDetails: {
        entityClassificationCode: 'EMAIL',
        entityFormatCode: 'EMAIL',
        entityValue: emailAddress
      },
      preferenceRequestGroup: [{
        preferenceCode: GLOBAL_PREF_CODE,
        preferenceStatus: preferenceStatus === 'U' || preferenceStatus === 'O' ? 'O' : 'I',
        preferenceReceiptTime: formatOptioTimestamp()
      }],
      auditInformation: {
        correlationId: correlationIdGenerator()
      }
    };
    const updateHeaders = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`
    };
    const response = await axios.post((_envConfig$env4 = envConfig[env]) === null || _envConfig$env4 === void 0 ? void 0 : _envConfig$env4.EPCC_UPDATE_URL, updatePayload, {
      headers: updateHeaders
    });

    // // console.log('Update response:', response.data);

    return response.data;

    // return {
    //   requestTrackId: 'Dig_EML_Intl_Web-2025-12-29-16.52.24.650000',
    //   responseStatus: 'All Choice-Codes Processed',
    //   responseCode: 'SUCCESS',
    // };
  } catch (error) {
    var _error$response3, _error$response4;
    const errorData = {
      message: error.message,
      response: (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data,
      status: (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status,
      emailAddress,
      timestamp: new Date().toISOString()
    };
    console.error('updatePrivacyPreferences error:', errorData);
    return {
      error,
      errorData
    };
  }
};
export const forceOptOutForSkipMarkets = async ({
  emailAddress,
  appToken,
  env
}) => {
  try {
    var _envConfig$env5, _envConfig$env6;
    // Step 1: Get JWT
    // const tokenRes = await getApplicationToken({ appId, secret, tokenUrl: tokenUrlParam });

    // if (!tokenRes?.authorization_token) {
    //   if (tokenRes?.error) return tokenRes;
    //   throw new Error('Token not received');
    // }
    if (!appToken) {
      throw new Error('Token not received');
    }
    const jwt = appToken;

    // Step 2: Build correct Optio update payload
    const updatePayload = {
      requestorInformation: {
        interfaceRelationshipId: (_envConfig$env5 = envConfig[env]) === null || _envConfig$env5 === void 0 ? void 0 : _envConfig$env5.EPCC_INTERFACE_RELATIONSHIP_ID
      },
      customerDetails: {
        entityClassificationCode: 'EMAIL',
        entityFormatCode: 'EMAIL',
        entityValue: emailAddress
      },
      preferenceRequestGroup: [{
        preferenceCode: GLOBAL_PREF_CODE,
        preferenceStatus: 'O',
        // force opt-out
        preferenceReceiptTime: formatOptioTimestamp()
      }],
      auditInformation: {
        correlationId: correlationIdGenerator()
      }
    };
    const updateHeaders = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`
    };
    const response = await axios.post((_envConfig$env6 = envConfig[env]) === null || _envConfig$env6 === void 0 ? void 0 : _envConfig$env6.EPCC_UPDATE_URL, updatePayload, {
      headers: updateHeaders
    });

    // // console.log('Update response:', response.data);

    return response.data;

    // //! mock response for now
    // return {
    //   requestTrackId: 'Dig_EML_Intl_Web-2025-12-29-16.52.24.650000',
    //   responseStatus: 'All Choice-Codes Processed',
    //   responseCode: 'SUCCESS',
    // };
  } catch (error) {
    var _error$response5, _error$response6;
    const errorData = {
      message: error.message,
      response: (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.data,
      status: (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.status,
      emailAddress,
      timestamp: new Date().toISOString()
    };
    console.error('forceOptOutForSkipMarkets error:', errorData);
    return {
      error,
      errorData
    };
  }
};